import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { EmailForm } from './EmailForm';

export const Audit: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="audit" className="w-full py-32 px-6 border-y border-white/10 bg-white/[0.02]">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block px-3 py-1 border border-emerald/30 bg-emerald/5 text-emerald font-mono text-xs tracking-wider mb-8">
          {t.audit.label}
        </span>
        
        <h2 className="text-4xl md:text-5xl text-white font-light mb-6 tracking-tight">
          {t.audit.title}
        </h2>
        
        <p className="text-lg text-mutedGray font-light mb-10 leading-relaxed max-w-xl mx-auto">
          {t.audit.description}
        </p>

        <div className="flex flex-col items-center gap-6">
          <EmailForm />
          <span className="text-[10px] font-mono text-zinc-600 uppercase tracking-widest">
            {t.audit.response}
          </span>
        </div>
      </div>
    </section>
  );
};